import axios from "axios";

const empDetailsAxios = axios.create({
  baseURL: "https://esystems.cdl.lk/backend/AttendMe2/",
});

// Forward the auth token from the default axios instance on every request.
empDetailsAxios.interceptors.request.use((config) => {
  const token =
    axios.defaults.headers.common["Authorization"] ||
    axios.defaults.headers.common["token"];
  if (token) {
    config.headers["Authorization"] = token;
  }
  return config;
});

const EmpDetailsService = {
  GetEmployeeDetails: (serviceNo) =>
    empDetailsAxios.get(
      `EmployeeDetails/GetEmployeeDetails?serviceNo=${serviceNo}`
    ),

  // Returns a plain URL string (used as an <img> src), not an axios call.
  GetEmployeeImage: (serviceNo) =>
    `https://esystems.cdl.lk/backend-test/AttendMe2/Home/GetDTSUserImg?serviceNo=${serviceNo}`,

  GetEmployeeOtherInfo: (serviceNo) =>
    empDetailsAxios.get(
      `EmployeeDetails/GetEmployeeOtherInfo?serviceNo=${serviceNo}`
    ),

  GetEmployeeNoPay: (serviceNo, currentYear, startMonth, endMonth, newYear) =>
    empDetailsAxios.get(
      `EmployeeDetails/GetEmployeeNoPay?serviceNo=${serviceNo}&currentYear=${currentYear}&startMonth=${startMonth}&endMonth=${endMonth}&newYear=${newYear}`
    ),

  GetEmployeePreYearSummary: (serviceNo) =>
    empDetailsAxios.get(
      `EmployeeDetails/GetEmployeePreYearSummary?serviceNo=${serviceNo}`
    ),

  GetEmployeeList: () =>
    empDetailsAxios.get("EmployeeDetails/GetEmployeeList"),
};

export default EmpDetailsService;